export const MuiTypography = {
  defaultProps: {
    color: 'text.main',
    variant: 'baseRegular'
  }
}
